import { Fade } from 'react-reveal';

import "./index.scss";

const OurMission = () => (
  <div className="our-mission">
    <Fade left >
      <div>
        At Omni-Active® Fitness, our mission is to optimize your strength and movement. Founded in 2012, we bring fitness
        training straight to your home.
    </div>
    </Fade>
    <Fade right >
      <div>
        You can count on one of our professional trainers to help you exercise efficiently and effectively, no matter your
        location. We specialize in convenient, customized, and creative workouts that will help you reach your goals
        faster!
    </div>
    </Fade>
    <Fade left >
      <div>
        Whether you prefer independent guidance with our online programming through our app or a more hands-on approach
        with our in-person training, we’re here for you. Let’s meet your fitness goals together!
    </div>
    </Fade>
  </div>
);

export default OurMission;
